import { createSlice } from '@reduxjs/toolkit'

const initialState: {
  locale: string | null
} = {
  locale: null,
}

export const { actions: languageActions, reducer: languageReducer } = createSlice({
  name: '@app/language',
  initialState,
  reducers: {
    changed: (state, { payload }: { payload: string }) => {
      state.locale = payload
    },
  },
})
